import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex align-items-center flex-wrap me-3 mb-md-5 mb-lg-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "d-none d-lg-flex d-flex align-items-center text-dark fw-bolder fs-3 my-1" }, "Communications"),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mx-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-flex overflow-auto h-55px" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "d-none d-md-flex py-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.userStore.canManage(_ctx.userStore.currentEntity) && !_ctx.isOrganization)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Button, {
            onClick: _ctx.invokeAddCommunication,
            class: "btn-sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Send Communication")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}